<!-- Latest CDN production CSS -->
<link
  href="https://global.oktacdn.com/okta-signin-widget/5.3.3/css/okta-sign-in.min.css"
  type="text/css"
  rel="stylesheet"
/>

@if (isSrmMaintenanceMode()) {
  <app-maintenance-mode></app-maintenance-mode>
} @else {
  <app-notify
    aria-live="polite"
    aria-atomic="true"
  ></app-notify>
  <app-notify-with-action />

  @if (browserNotSupported) {
    <div class="browserNotSupported">
      <h1>Your Browser is NOT Supported</h1>
    </div>
  } @else {
    @if (authService.loadingSession$ | async) {
      <div class="load">
        <img
          title="loading"
          class="loading-logo"
          src="/assets/sustainment-icons/sustain-icon-white.png"
        />
      </div>
    }
    <router-outlet></router-outlet>
    <p-confirmDialog
      styleClass="dialog-sm"
      [key]="'confirmUnsavedChangesVendor'"
    ></p-confirmDialog>
  }
}

<p-confirmDialog
  [key]="'timoutDialog'"
  [closable]="false"
  [baseZIndex]="10000"
  styleClass="dialog-sm"
></p-confirmDialog>
<p-confirmDialog
  class="unsaved-changes"
  styleClass="dialog-sm"
  [key]="'unsavedChanges'"
/>
<p-confirmDialog
  key="session-expired"
  [closable]="false"
  styleClass="dialog-sm"
></p-confirmDialog>
